import React from 'react';
import "./Footer.css"

const Footer = () => {
    return (
        <p className="footer-link">
            <a href="https://github.com/doltitol/weather-app" target="_blank" rel='noreferrer'>
                Open-source code
            </a>{ " " }
            by Oludolapo Adegoroye
        </p>
    )
}

export default Footer